/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Tawk_DescriptionInputs */

const en_admin_settings_groups_tawk_description = /** @type {(inputs: Admin_Settings_Groups_Tawk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawk.to live chat widget`)
};

/**
* | output |
* | --- |
* | "Tawk.to live chat widget" |
*
* @param {Admin_Settings_Groups_Tawk_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_tawk_description = /** @type {((inputs?: Admin_Settings_Groups_Tawk_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Tawk_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_tawk_description(inputs)
});
export { admin_settings_groups_tawk_description as "admin.settings.groups.tawk.description" }